import { isNumeric } from '#shared/index'

function normalizePath(path: string) {
  if (path.endsWith('/')) return path.slice(0, -1)
  return path
}

export function getFullscreenChatHref(chatId: number | string, messageId?: number | string) {
  const normalizedFullscreenChatBaseUrl: string = normalizePath(import.meta.env.VITE_FULLSCREEN_CHAT_BASE_URL || '')
  const normalizedBasepath = normalizePath(import.meta.env.VITE_BASEPATH || '')

  const queryParams = new URLSearchParams()

  if (isNumeric(messageId)) {
    queryParams.set('targetMessageId', messageId?.toString() ?? '')
    queryParams.set('navnonce', Date.now().toString())
  }

  let url = `${normalizedFullscreenChatBaseUrl}${normalizedBasepath}/${chatId}`

  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`
  }

  return url
}
